import { Component, Input, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityIdentificationComponent } from './components/entity-identification/entity-identification.component';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { BncsAssessmentComponent } from './components/bncs-assessment/bncs-assessment.component';
import { DdqSpecificFieldsComponent } from './components/ddq-specific-fields/ddq-specific-fields.component';
import { LoaTrackingComponent } from './components/loa-tracking/loa-tracking.component';
import {
  LegalEntityDetailDto,
  ContactInformationDto,
  DocumentFile,
} from '../../models/legal-entity.models';
import { SelectedLegalEntityService } from '../../../../shared/services/selected-legal-entity.service';
import { LegalEntityService } from '../../services/legal-entity.service';
import { LoggerService } from '../../../../core/logging/logger.service';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-legal-entity-information',
  standalone: true,
  imports: [
    CommonModule,
    EntityIdentificationComponent,
    ContactInformationComponent,
    BncsAssessmentComponent,
    DdqSpecificFieldsComponent,
    LoaTrackingComponent,
    SpinnerComponent,
  ],
  templateUrl: './legal-entity-information.component.html',
  styleUrl: './legal-entity-information.component.scss',
})
export class LegalEntityInformationComponent {
  @Input() entityId: number | null = null;

  loading = true;

  legalEntityName = '';
  officialRegistrationNumber = '';
  associatedAuthorizedSignatory = '';
  address = '';
  country = '';

  contactInformation: ContactInformationDto[] = [];

  bncsAssessmentDocuments: DocumentFile[] = [];

  constructor(
    private selectedLegalEntity: SelectedLegalEntityService,
    private legalEntityService: LegalEntityService,
    private logger: LoggerService,
  ) {
    effect(() => {
      const detail = this.selectedLegalEntity.entityDetail();
      const isStatusLoading = this.selectedLegalEntity.statusLoading();
      const isDdqFieldsLoading = this.selectedLegalEntity.ddqFieldsLoading();
      const isRemediationActionsLoading = this.selectedLegalEntity.remediationActionsLoading();
      const isLoaDocumentsLoading = this.selectedLegalEntity.loaDocumentsLoading();

      // Show loader if any of the requests is still loading
      this.loading =
        isStatusLoading ||
        isDdqFieldsLoading ||
        isRemediationActionsLoading ||
        isLoaDocumentsLoading;

      if (detail && detail.legal_entity.id === this.entityId) {
        this.populateFields(detail);
      }
    });
  }

  private populateFields(detail: LegalEntityDetailDto): void {
    this.legalEntityName = detail.legal_entity.name || '';
    this.address = detail.legal_entity.address || '';
    this.country = detail.legal_entity.country || '';

    if (detail.entity_identification) {
      this.officialRegistrationNumber = detail.entity_identification.registration_number || '';
      this.associatedAuthorizedSignatory = detail.entity_identification.signatories || '';
    } else {
      this.officialRegistrationNumber = '';
      this.associatedAuthorizedSignatory = '';
    }

    if (detail.contact_information && detail.contact_information.length > 0) {
      this.contactInformation = detail.contact_information;
    } else {
      this.contactInformation = [];
    }

    if (detail.b_and_cs_assessment_documents && detail.b_and_cs_assessment_documents.length > 0) {
      this.bncsAssessmentDocuments = detail.b_and_cs_assessment_documents;
    } else {
      this.bncsAssessmentDocuments = [];
    }
  }

  onContactsChanged(contacts: ContactInformationDto[]): void {
    this.contactInformation = contacts;
  }
}
